/**
 * 动态表单组件注册类
 * 提供注册和获取方法
 */
class WidgetRegistry {
  widgets = new Map();

  defaultWidget;

  /**
   * 设置默认组件，以便找不到type对应的逐渐时候显示
   * @param widget
   */
  setDefault (widget) {
    this.defaultWidget = widget
  }

  /**
   * 注册动态表单组件
   * @param type
   * @param widget
   */
  register (type, widget) {
    this.widgets.set(type, widget)
  }

  /**
   * 判断指定的组件名称是否存在
   * @param type
   */
  has (type) {
    return this.widgets.has(type)
  }

  /**
   * 根据指定类型获取动态组件
   * @param type
   */
  getType (type) {
    if (this.has(type)) {
      return this.widgets.get(type)
    }
    return this.defaultWidget
  }
}

const widgetRegistry = new WidgetRegistry()
export default widgetRegistry



// WEBPACK FOOTER //
// ./src/components/DynamicForm/WidgetRegistry.js